export default {
  schedule: {
    type: Object,
    require: true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/agendas/schedulings/scheduled/index/components/cancel/resources/props.js